import React from "react";
import { FiX } from "react-icons/fi";

const CustomModal = ({ closeIcon = false, open, onClose, children }) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 z-50">
      <div className="w-screen h-screen bg-backdrop flex justify-center items-center">
        <div className="bg-white w-8/12 h-[600px] relative lg:w-4/12 rounded-xl">
          {closeIcon && (
            <button
              className="bg-white-200 p-5 text-5xl text-gray-700 rounded absolute top-0 right-0"
              onClick={onClose}
            >
              <FiX />
            </button>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
